module.exports = __webpack_public_path__ + "static/media/oberflex-noyergrisflanelle-2560x1440.79b1e76c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyergrisflanelle-2560x1440.jpg
// module id = 1043
// module chunks = 37